define('editor/edit/map/controls/coordinator',['durandal/app', 'plugins/router', 'jquery', 'plugins/http', 'plugins/dialog', './legend', './textblock', './minimap', './scalebar', './viewport', './attribution', './drawing-tools', './directions', './overlay', './location-zoom', './title', './tile-layer-switch', './boundaries', 'spin'], function (app, router, $, http, dialog, legendControl, textBlockControl, minimapControl, scalebarControl, viewportControl, attributionControl, drawingTools, directionsControl, overlayControl, locationZoomControl, titleControl, tileLayerSwitcherControl, boundaries, Spinner) {
    var controller = function(editorMap, mapControl, isRenderMode, tileLayers) {
        var self = this;

        self.editorMap = editorMap;
        self.mapControl = mapControl;
        self.isRenderMode = isRenderMode || false;
        self.router = router;
        self.drawingTools = null;
        self.titleControl = null;
        self.controls = [];
        self.tileLayers = tileLayers;
        self.editingLayerId = null;
        self.spinner = null;

        self.initialise = function() {
            self.initialiseMapScrollBreakpoints();
            
            if (!self.isRenderMode) {
                self.addLocationZoomer();
                self.addTitle();
                self.addTileLayerSwitcher();
                self.addViewport();
            }
            
            self.addDrawingTools();
            self.addBoundaries();
            self.addAttribution();
            self.registerEventHandlers();
        };

        self.destroy = function() {
            self.boundaries.destroy();
        };

        self.initialiseMapScrollBreakpoints = function () {
            self.mapControl._container.className += ' min-w-' + self.editorMap.width;
            self.mapControl._container.className += ' min-h-' + self.editorMap.height;
        };

        self.addLocationZoomer = function() {
            self.addLocationZoomer = new locationZoomControl({
                editorMapId: self.editorMap.id,
                mapControl: self.mapControl
            });

            self.addLocationZoomer.addToMap();
        };

        self.addDrawingTools = function () {
            self.drawingTools = new drawingTools({
                editorMapId: self.editorMap.id,
                mapControl: self.mapControl
            });

            self.drawingTools.addToMap(!self.isRenderMode);
        };

        self.addBoundaries = function() {
            self.boundaries = new boundaries({
                editorMapId: self.editorMap.id,
                mapControl: self.mapControl
            });

            self.boundaries.initialise();
        };

        self.addTitle = function() {
            var opts = {
                mapControl: self.mapControl,
                editorMap: self.editorMap
            };

            self.titleControl = new titleControl(opts);

            self.titleControl.addToMap();
        };

        self.addViewport = function() {
            var opts = {
                mapControl: self.mapControl,
                editorMap: self.editorMap
            };

            app.viewportControl = new viewportControl(opts);

            app.viewportControl.addToMap();
        };

        self.getBoundingBox = function() {
            app.viewportControl.getBoundingBox();
        };

        self.addTileLayerSwitcher = function() {
            var opts = {
                mapControl: self.mapControl,
                editorMap: self.editorMap,
                tileLayers: self.tileLayers
            };

            self.tileLayerSwitcherControl = new tileLayerSwitcherControl(opts);

            self.tileLayerSwitcherControl.addToMap();
        };

        self.addAttribution = function() {
                var opts = {
                    mapControl: self.mapControl,
                    editorMap: self.editorMap
                };

            self.attributionControl = new attributionControl(opts);

            self.attributionControl.addToMap();
        };

        self.registerEventHandlers = function () {
            // initial layers load
            app.on('layers:newData', self.refreshControls); 
            app.on('layer:new', self.addLayerControl);
            app.on('map:settings:updated', self.handleMapSettingsChanged);
            app.on('layer:visibility', self.onLayerVisibilityToggle);
            app.on('layer:editing', self.onEditingLayer);
            app.on('layers:updated', self.onLayersUpdated);
            app.on('layer:saved', self.onEditLayerComplete);
            app.on('layers:deleted', self.deleteLayerControls);
            app.on('spinner:show', self.showSpinner);
            app.on('spinner:hide', self.hideSpinner);
        };

        self.showSpinner = function () {
            if (self.spinner === null) {
                self.spinner = new Spinner().spin(document.getElementById("mapbox-map"));
            } else {
                self.spinner.spin(document.getElementById("mapbox-map"));
            }
        };

        self.hideSpinner = function() {
            self.spinner.stop();
        };

        self.refreshControls = function (layers) {
            self.clear();

            self.arrangeMapControls(layers);
        };

        self.addLayerControl = function (layer) {
            self.createControl(layer);
        };

        self.clear = function () {
            for (var i = 0; i < self.controls.length; i++) {
                self.controls[i].remove();
            }

            self.controls = [];
        };

        self.onEditingLayer = function (layer) {
            var idx = self.findControl(layer.id().toLowerCase());

            if (~idx) {
                var control = self.controls[idx];

                self.editingLayerId = layer.id();

                if (control.allowEdit) {
                    control.allowEdit();
                }
            }
        };

        self.onLayersUpdated = function (layers) {
            var layersLen = layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = layers[i];
                
                var idx = self.findControl(layer.id().toLowerCase());
                
                if (~idx) {
                    self.deleteLayerControls([layer]);
                    self.createControl(layer);

                    if (self.editingLayerId === layer.id().toLowerCase()) {
                        var control = self.controls[self.controls.length - 1];

                        if (control.allowEdit) {
                            control.allowEdit();
                        }
                    }
                }
            }
        };

        self.onEditLayerComplete = function (layer) {
            var idx = self.findControl(layer.id().toLowerCase());

            if (~idx) {
                self.editingLayerId = null;
                self.deleteLayerControls([layer]);
                self.createControl(layer);
            }
        };

        self.onLayerVisibilityToggle = function (layer) {
            var idx = self.findControl(layer.id().toLowerCase()),
                f = layer.visible() ? 'show' : 'hide';

            if (~idx) {
                self.controls[idx][f].call(undefined);
            }
        };
        
        self.deleteLayerControls = function (layers) {
            var deletedLayersLen = layers.length,
                layerToDelete;

            for (var i = 0; i < deletedLayersLen; i++) {
                layerToDelete = layers[i];
                var idx = self.findControl(layerToDelete.id().toLowerCase());
                
                if (~idx) {
                    var control = self.controls[idx];
                    self.controls.splice(idx, 1);
                    control.remove();
                    control = undefined;
                }
            }
        };

        self.findControl = function (layerId) {
            var idx = -1,
                controlsLen = self.controls.length;
            
            for (var i = 0; i < controlsLen; i++) {
                if (self.controls[i].layer.id() === layerId) {
                    return i;
                }
            }

            return idx;
        };

        self.arrangeMapControls = function (layers) {
            var layersLen = layers().length;
                
            if (!layersLen) {
                return;
            }

            for (var i = 0; i < layersLen; i++) {
                var layer = layers()[i];

                self.createControl(layer);
            }
        };

        self.createControl = function(layer) {
            switch (layer.type()) {
                case "Legend":
                    self.addLegend(layer);
                    break;
                case "TextBlock":
                    self.addTextBlock(layer);
                    break;
                case "MiniMap":
                    self.addMiniMap(layer);
                    break;
                case "ScaleBar":
                    self.addScaleBar(layer);
                    break;
                case "Directions":
                    self.addDirectionsLayer(layer);
                    break;
                case "Overlay":
                    self.addCustomOverlay(layer);
                    break;
                // more layer types...
                default:
                    break;
            }
        };

        self.addDirectionsLayer = function(layer) {
            var opts = {
                mapControl: self.mapControl,
                editorMap: self.editorMap,
                layer: layer
            };

            var directions = new directionsControl(opts);
            
            self.controls.push(directions);

            directions.addToMap();
        };

        self.addCustomOverlay = function (layer) {
            var opts = {
                mapControl: self.mapControl,
                layer: layer
            };
            var overlay = new overlayControl(opts);

            self.controls.push(overlay);

            overlay.addToMap();
        };

        self.addLegend = function (layer) {
            var opts = {
                mapControl: self.mapControl, 
                editorMap: self.editorMap, 
                layer: layer,
                visible: layer.visible
            };

            var legend = new legendControl(opts);

            self.controls.push(legend);
            
            legend.addToMap();
        };

        self.addTextBlock = function (layer) {
            var opts = {
                mapControl: self.mapControl, 
                editorMap: self.editorMap, 
                layer: layer,
                visible: layer.visible
            };

            var textBlock = new textBlockControl(opts);

            self.controls.push(textBlock);
            
            textBlock.addToMap();
        };

        self.addMiniMap = function (layer) {
            var opts = {
                mapControl: self.mapControl, 
                editorMap: self.editorMap, 
                layer: layer
            };

            var minimap = new minimapControl(opts);

            self.controls.push(minimap);

            minimap.addToMap();
        };

        self.addScaleBar = function (layer) {
            var attributionHeight = self.attributionControl.getHeight(),
                opts = {
                    mapControl: self.mapControl,
                    editorMap: self.editorMap,
                    layer: layer,
                    yOffset: attributionHeight
                },
                scaleBar = new scalebarControl(opts);
            
            scaleBar.addToMap();

            self.controls.push(scaleBar);
        };

        self.handleMapSettingsChanged = function (settings) {
            var dimensions = {
                height: settings.height,
                width: settings.width
            },
            mapClass = self.mapControl._container.className;

            mapClass = mapClass.replace('min-w-' + self.editorMap.width, 'min-w-' + settings.width);
            mapClass = mapClass.replace('min-h-' + self.editorMap.height, 'min-h-' + settings.height);

            self.mapControl._container.className = mapClass;

            self.editorMap.height = dimensions.height;
            self.editorMap.width = dimensions.width;

            self.titleControl.updateTitle(settings.title);
            app.viewportControl.updateDimensions(dimensions);
            self.attributionControl.updateDimensions(dimensions);
            self.refreshStaticControls(dimensions);
        };

        self.refreshStaticControls = function (newDimensions) {
            var controlsLen = self.controls.length;

            for (var i = 0; i < controlsLen; i++) {
                var control = self.controls[i],
                    layerType = control.options.layer.type();

                if (layerType === "MiniMap" || layerType === "TextBlock" || layerType === "ScaleBar") {
                    control.options.viewport = newDimensions;
                    control.remove();
                    control.addToMap();
                }
            }
        };
    };

    return controller;
});

